var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _rect, _path14, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTypelogostyleversionstatedefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 44,
    viewBox: "0 0 174 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.847 32.8354L99.3288 12.7016C99.06 12.068 98.4328 11.653 97.7384 11.653C97.044 11.653 96.4168 12.0648 96.148 12.7016L87.6263 32.8322C87.2583 33.7034 87.6711 34.7014 88.5511 35.0657C89.4311 35.4301 90.4391 35.0214 90.8072 34.1501L93.6296 27.4843H101.844L104.666 34.1533C104.942 34.8091 105.585 35.202 106.257 35.202C106.478 35.202 106.705 35.1608 106.922 35.0689C107.802 34.7046 108.215 33.7034 107.847 32.8354ZM95.076 24.0722L97.7384 17.7802L100.401 24.0722H95.076Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.627 35.3856C111.567 35.3856 110.71 34.5366 110.71 33.4879V18.7718C110.71 17.7231 111.567 16.874 112.627 16.874C113.686 16.874 114.543 17.7231 114.543 18.7718V33.4879C114.543 34.5366 113.686 35.3856 112.627 35.3856Z",
    fill: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.583 41.3642C126.583 41.7602 126.916 42.0802 127.329 42.0802C127.511 42.0802 127.722 41.9693 127.876 41.8584L127.898 41.8425L136.993 34.6445L127.959 26.0682C127.402 25.6215 126.574 26.0144 126.574 26.5529V32.0624C126.574 32.8671 125.742 33.0128 125.14 32.7752L123.534 32.1891C123.473 32.1669 123.412 32.1416 123.361 32.1036C122.938 31.8121 122.759 31.3084 122.759 30.868V14.9669C122.759 13.9595 123.585 13.1421 124.602 13.1421H133.278C135.678 13.1547 139.23 15.005 139.23 19.0571C139.23 19.8364 139.127 20.8756 138.961 21.4554C138.609 22.6814 137.975 23.6097 137.412 24.1166C135.793 25.574 133.966 25.5898 133.358 25.555L132.98 25.5455L140.129 32.0941C142.699 29.3568 144.199 25.6659 143.979 21.6328C143.582 14.4347 137.604 8.55139 130.154 8.03815C126.538 7.78786 123.172 8.78267 120.465 10.6234C118.932 11.6657 118.052 13.386 118.052 15.195V29.6546C118.052 31.4731 118.954 33.1903 120.497 34.2358C122.11 35.3256 123.63 36.067 125.62 36.4757C126.238 36.6024 126.561 36.9984 126.561 37.8506",
    fill: "url(#paint0_linear_237_8870)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133.223 21.5754C133.402 21.5754 134.029 21.5026 134.455 21.1065C134.778 20.8087 135.025 20.3177 135.025 19.551C135.025 17.6247 133.969 17.1717 133.079 17.1305H127.255C126.785 17.1305 126.404 17.5075 126.404 17.9732V20.7359C126.404 21.2016 126.785 21.5786 127.255 21.5786H133.015L133.22 21.5723L133.223 21.5754Z",
    fill: "url(#paint1_linear_237_8870)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2049 12.3626V23.8948H7.28645V15.2393H0V12.3626H10.2049Z",
    fill: "#212121"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.93924 20.5172V27.2274H10.2049V30.1136H0V27.2274H3.02402V20.5172H5.94244H5.93924Z",
    fill: "#212121"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8304 11.4435V17.4599H19.8368V20.3493H15.8304V35.1826H12.912V11.4435H15.8304Z",
    fill: "#212121"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2005 11.4435V17.4599H85.2069V20.3493H81.2005V35.1826H78.2853V11.4435H81.2005Z",
    fill: "#212121"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6758 12.3024C67.4438 12.3024 64.8102 14.9067 64.8102 18.1097C64.8102 21.3127 67.4406 23.9169 70.6758 23.9169C73.911 23.9169 76.5415 21.3127 76.5415 18.1097C76.5415 14.9067 73.911 12.3024 70.6758 12.3024ZM70.6758 21.0307C69.047 21.0307 67.7222 19.7191 67.7222 18.1065C67.7222 16.4939 69.047 15.1823 70.6758 15.1823C72.3046 15.1823 73.6294 16.4939 73.6294 18.1065C73.6294 19.7191 72.3046 21.0307 70.6758 21.0307Z",
    fill: "#212121"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5829 12.3751V15.255H51.898V20.945H60.5829V23.8376H56.3589V27.2497H60.5829V30.1422H48.9796V27.2497H53.4404V23.8376H48.9796V12.3719H60.5829V12.3751Z",
    fill: "#212121"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8069 32.1922C51.5204 32.1922 48.8452 34.8408 48.8452 38.0945C48.8452 41.3482 51.5204 44 54.8069 44C58.0933 44 60.7717 41.3514 60.7717 38.0945C60.7717 34.8376 58.0965 32.1922 54.8069 32.1922ZM54.8069 41.1043C53.13 41.1043 51.7668 39.7546 51.7668 38.0945C51.7668 36.4344 53.13 35.0847 54.8069 35.0847C56.4837 35.0847 57.8469 36.4344 57.8469 38.0945C57.8469 39.7546 56.4837 41.1043 54.8069 41.1043Z",
    fill: "#212121"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.49 11.4406V14.0607H26.0643V11.4406H32.49Z",
    fill: "#212121"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7124 11.4435V17.4599H43.7221V20.3493H39.7124V32.306H43.5173V43.8318H40.5989V35.1795H33.3092V32.306H36.7972V11.4435H39.7092H39.7124Z",
    fill: "#212121"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7811 15.309H23.645V18.0463H24.5794L24.541 18.1381C24.2786 18.7496 24.141 19.4308 24.141 20.1087C24.141 22.8809 26.4194 25.1366 29.2195 25.1366C32.0195 25.1366 34.2979 22.8809 34.2979 20.1087C34.2979 19.4276 34.1603 18.7654 33.8915 18.1381L33.8531 18.0463H34.7875V15.309H34.7811ZM29.2163 22.336C27.9746 22.336 26.9634 21.3348 26.9634 20.1056C26.9634 18.8763 27.9746 17.872 29.2163 17.872C30.4579 17.872 31.4691 18.8732 31.4691 20.1056C31.4691 21.338 30.4579 22.336 29.2163 22.336Z",
    fill: "#212121"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M114.895 12.1786C114.895 13.4363 113.878 14.4565 112.623 14.4565C111.369 14.4565 110.351 13.4363 110.351 12.1786C110.351 10.9208 111.369 9.90381 112.623 9.90381C113.878 9.90381 114.895 10.924 114.895 12.1786Z",
    fill: "url(#paint2_linear_237_8870)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 146,
    width: 28,
    height: 18,
    rx: 9,
    fill: "url(#paint3_linear_237_8870)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M155.22 4.53C157.05 4.53 158.13 5.61 158.13 7.09C158.13 7.94 157.72 8.67 156.29 10.15L155.12 11.36H158.29V12.9H152.46V11.86L155.13 9.11C156.11 8.1 156.34 7.57 156.34 7.11C156.34 6.51 156.01 6.11 155.22 6.11C154.48 6.11 154.08 6.71 154.08 7.33H152.29C152.29 5.73 153.5 4.53 155.22 4.53ZM159.84 10.98C160.41 10.98 160.83 11.41 160.83 11.98C160.83 12.55 160.41 12.98 159.84 12.98C159.26 12.98 158.84 12.55 158.84 11.98C158.84 11.41 159.26 10.98 159.84 10.98ZM164.217 4.53C165.997 4.53 167.337 5.96 167.337 8.82C167.337 11.67 165.997 13.1 164.217 13.1C162.437 13.1 161.097 11.67 161.097 8.82C161.097 5.96 162.437 4.53 164.217 4.53ZM164.217 6.12C163.417 6.12 162.817 6.96 162.817 8.82C162.817 10.67 163.417 11.51 164.217 11.51C165.017 11.51 165.617 10.67 165.617 8.82C165.617 6.96 165.017 6.12 164.217 6.12Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_237_8870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.105 15.7979C150.685 17.1685 152.745 18 155 18H155.934C151.919 21.682 146 22 146 22C148.056 20.7103 148.821 17.7633 149.105 15.7979Z",
    fill: "url(#paint4_linear_237_8870)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_237_8870",
    x1: 115.329,
    y1: 9.3466,
    x2: 138.988,
    y2: 33.2432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8459FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5143E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_237_8870",
    x1: 125.499,
    y1: 17.3063,
    x2: 127.586,
    y2: 22.6709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8459FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5143E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_237_8870",
    x1: 109.874,
    y1: 10.0837,
    x2: 112.915,
    y2: 14.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8459FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5143E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_237_8870",
    x1: 149.62,
    y1: -1.94771,
    x2: 175.522,
    y2: 13.1514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E95FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C59F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_237_8870",
    x1: 147.284,
    y1: 15.1267,
    x2: 156.336,
    y2: 20.5593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E95FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C59F8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_237_8870"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 7,
    fill: "white",
    transform: "translate(146 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypelogostyleversionstatedefault);
export default __webpack_public_path__ + "static/media/type=logo, style=version, state=default.79b23a4ca4bf0ee603b6019e235f13a4.svg";
export { ForwardRef as ReactComponent };